import styled from '@emotion/styled';
import { theme } from '~/theme';

export const FormWrapper = styled.div(() => ({
    ...theme.mixins.useTextStyle('bodySmall'),
    padding: theme.space[3],
    width: '100%',
    marginTop: theme.space[2],
    maxWidth: '100%',

    border: `1px solid ${theme.colors.black}`,
    borderRadius: theme.space[1],

    '& p': {
        marginBottom: theme.space[1],
    },
}));

export const StyledEditButton = styled.div(() => ({
    ...theme.mixins.useTextStyle('bodySmall'),
    textDecoration: 'underline',
    textTransform: 'capitalize',
    fontWeight: theme.fontWeights.medium,
    cursor: 'pointer',
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledFullName = styled.div(() => ({
    fontWeight: theme.fontWeights.medium,
}));
